<template>
  <ts-card>
    <ts-card-wrapper>
      <ts-loading-banner>
        <form class="form-horizontal ts-space-y-3">
          <div
            class="ts-border ts-border-gray-300 ts-rounded-md ts-p-4 ts-space-y-2 mb-3"
          >
            <div class="row">
              <label
                class="col-md-3 col-form-label ts-text-xs required ts-font-light"
              >
                {{ $t('productPriceSchema.tableType') }}
              </label>
              <div class="col-md-4">
                <Select v-model="model.guest_level_id">
                  <Option
                    v-for="(guestLevel, index) in guestLevels"
                    :value="guestLevel.id"
                    :key="index"
                    >{{ guestLevel.guest_level_name_en }}
                  </Option>
                </Select>
                <div
                  class="validate ts-text-xs"
                  v-if="errors.has('guest_level_id')"
                >
                  {{ errors.first('guest_level_id') }}
                </div>
              </div>
            </div>
            <div class="row">
              <label
                class="col-md-3 col-form-label ts-text-xs required ts-font-light"
              >
                {{ $t('productPriceSchema.incrementType') }}
              </label>
              <div class="col-md-4">
                <Select
                  v-model="model.increment_type"
                  :currency="defaultCurrencySign"
                >
                  <Option value="%">%</Option>
                  <Option :value="defaultCurrencySign">
                    {{ defaultCurrencySign }}
                  </Option>
                </Select>
                <div
                  class="validate ts-text-xs"
                  v-if="errors.has('increment_type')"
                >
                  {{ errors.first('increment_type') }}
                </div>
              </div>
            </div>
            <div class="row">
              <label
                class="col-md-3 col-form-label ts-text-xs required ts-font-light"
              >
                {{ $t('productPriceSchema.incrementAmount') }}
              </label>
              <div class="col-md-4">
                <input
                  v-model="model.increment_amount"
                  type="number"
                  class="form-control"
                />
                <div
                  class="validate ts-text-xs"
                  v-if="errors.has('increment_amount')"
                >
                  {{ errors.first('increment_amount') }}
                </div>
              </div>
            </div>
          </div>
        </form>
        <div
          class="ts-border ts-border-gray-300 ts-rounded-md ts-p-4 ts-space-y-2 mb-3"
        >
          <h6
            class="ts-text-white ts-uppercase ts-bg-blue-500 ts-px-2 ts-py-1 ts-rounded-md"
            style="width: fit-content"
          >
            {{ $t('promotion.productItem') }}
          </h6>
          <ts-checkbox
            class="ts-font-light"
            v-model="model.is_all_product"
            @change="() => (model.product_id_list = [])"
            >{{ $t('promotion.applyForAllProduct') }}</ts-checkbox
          >
          <div class="ts-overflow-auto ts-mt-2" style="max-height: 40vh">
            <table class="ts-w-full ts-mt-4">
              <thead>
                <tr>
                  <th>
                    {{ $t('productPriceSchema.productCode') }}
                  </th>
                  <th>
                    {{ $t('productPriceSchema.productNameEn') }}
                  </th>
                  <th>
                    {{ $t('productPriceSchema.productNameKh') }}
                  </th>
                  <th>
                    {{ $t('productPriceSchema.uom') }}
                  </th>
                  <th class="text-center">
                    {{ $t('productPriceSchema.unitPrice') }}
                  </th>
                  <th class="ts-w-1">
                    <a
                      class="btn btn-xs btn-primary"
                      href="#"
                      @click.prevent="() => (show_form = true)"
                      v-if="!model.is_all_product"
                    >
                      <i class="fa fa-plus"></i>
                    </a>
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr
                  class="ts-border-b ts-border-gray-400"
                  v-for="(pro, index) in model.product_id_list"
                  :key="index"
                >
                  <td class="ts-text-xs">
                    {{ pro.barcode }}
                  </td>
                  <td class="ts-text-xs">
                    {{ pro.product_name_en }}
                  </td>
                  <td class="ts-text-xs">
                    {{ pro.product_name_kh }}
                  </td>
                  <td style="width: 10%">
                    <select
                      v-model.number="pro.uom_id"
                      class="form-control ts-w-full ts-border-b ts-outline-none ts-py-1 ts-px-2"
                      @change="onUomChange(pro)"
                      style="min-width: 100px"
                    >
                      <option
                        v-for="(u, uIndex) in getUom(pro.product_id)"
                        :key="uIndex"
                        :value="u.uom_id"
                      >
                        {{ u.unit_of_measure.uom_name_en }}
                      </option>
                    </select>
                    <div
                      class="validate"
                      v-if="errors.has('po_detail.' + index + '.uom_id')"
                    >
                      {{ errors.first('po_detail.' + index + '.uom_id') }}
                    </div>
                  </td>
                  <td class="ts-text-xs text-center">
                    {{ pro.unit_price }}
                  </td>
                  <td>
                    <a
                      href="#"
                      class="ts-text-red-700 hover:ts-text-red-700 text-center"
                      @click.prevent="removeItem(index)"
                    >
                      <i class="fa fa-trash"></i>
                    </a>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <div class="validate ts-text-xs" v-if="errors.has('product_id_list')">
            {{ errors.first('product_id_list') }}
          </div>
          <a-modal
            v-if="show_form"
            v-model="show_form"
            :title="$t('promotion.product')"
            :footer="null"
          >
            <ProductList v-model="model" />
          </a-modal>
        </div>
        <div class="row">
          <div
            class="col-md-12 ts-flex ts-items-center ts-space-x-3 ts-justify-end"
          >
            <ts-button
              @click.prevent="$router.push({ name: 'product-price-schema' })"
              >{{ $t('cancel') }}</ts-button
            >
            <ts-button
              color="primary"
              outline
              :waiting="waiting_new"
              @click.prevent="onSaveAddNew"
              >{{ $t('save_add_new') }}</ts-button
            >
            <ts-button
              :waiting="waiting"
              color="primary"
              @click.prevent="onSave"
              >{{ $t('save') }}</ts-button
            >
          </div>
        </div>
      </ts-loading-banner>
    </ts-card-wrapper>
  </ts-card>
</template>
<script>
import { mapActions, mapGetters, mapState } from 'vuex'
import ProductList from './product.vue'
import { Errors } from 'form-backend-validation'

export default {
  components: {
    ProductList
  },
  data() {
    return {
      loading: false,
      show_form: false,
      errors: new Errors(),
      waiting: false,
      waiting_new: false,
      model: {
        is_all_product: false,
        guest_level_id: null,
        increment_amount: null,
        increment_type: '%',
        product_id_list: []
      }
    }
  },
  created() {
    this.fetchResource()
  },
  computed: {
    ...mapGetters('restaurantSale/productPriceSchema', ['getUom', 'getPrice']),
    ...mapState('restaurantSale/productPriceSchema', ['guestLevels']),
    defaultCurrencySign() {
      return this.$store.state.authUser.sys_setting.default_currency_sign
    }
  },
  methods: {
    ...mapActions('restaurantSale/productPriceSchema', [
      'getProduct',
      'getGuestLevels'
    ]),
    fetchResource() {
      this.loading = true
      this.clearInput()
      this.getGuestLevels().then(level => {
        const findFale = level.data.find(l => !l.is_standard)
        if (findFale) {
          this.model.guest_level_id = findFale.id
        }
      })
      this.getProduct()
        .then(() => {})
        .catch(error => {
          this.notice({ type: 'error', text: error.message })
        })
        .finally(() => {
          this.loading = false
        })
    },
    onSave() {
      this.waiting = true
      this.$store
        .dispatch('restaurantSale/productPriceSchema/store', this.model)
        .then(response => {
          this.$toasted.success(response.message)
          this.$router.push({ name: 'product-price-schema' })
        })
        .catch(error => {
          this.$toasted.error(error.message)
          this.errors = new Errors(error.errors)
        })
        .finally(() => {
          this.waiting = false
        })
    },
    async onSaveAddNew() {
      this.errors = new Errors()
      this.waiting_new = true
      this.$store
        .dispatch('restaurantSale/productPriceSchema/store', this.model)
        .then(response => {
          this.$toasted.success(response.message)
          this.clearInput()
        })
        .catch(error => {
          this.$toasted.error(error.message)
          this.errors = new Errors(error.errors)
        })
        .finally(() => {
          this.waiting_new = false
        })
    },

    clearInput() {
      this.model.guest_level_id = null
      this.model.increment_amount = null
      this.model.increment_type = null
      this.model.product_id_list = []
    },
    removeItem(index) {
      this.model.product_id_list.splice(index, 1)
    },
    onUomChange(row) {
      row.unit_price = this.getPrice(row.product_id, row.uom_id)
    }
  }
}
</script>
<style lang="css" scoped>
table > thead > tr > th {
  background: rgb(238, 238, 238);
  position: sticky;
  position: -webkit-sticky;
  top: 0;
  z-index: 999;
  padding: 2px 7px;
}

table > tbody > tr > td {
  padding: 3px;
  border-bottom: 1px solid rgb(226, 226, 226);
}
</style>
